<template>
	<div class="row flex-row">
		<div v-for="item in items" :key="item.ID" class="columns column4 promotion">
			<div class="card-wrapper">
				<div class="card">
					<div class="content">
						<div class="front">
							<picture>
								<source :srcset="item.cardImageWebp" type="image/webp" />
								<source :srcset="item.cardImage" />
								<img :src="item.cardImage" :alt="item.cardImageAlt" loading="lazy" />
							</picture>
						</div>
						<nuxt-link class="back" :class="item.cardBackgroundColor" :to="localePath(`/${item.filename}`)">
							<div class="content-wrapper">
								<h3>
									{{ item.header }}
								</h3>
								<div v-parse-links v-html="item.overviewContent" />
								<div class="horizontal-divider" />
								<div v-parse-links class="details" v-html="item.details" />
							</div>
						</nuxt-link>
					</div>
				</div>
			</div>
			<div class="vertical-divider" />
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
	flex-flow: row wrap;
	align-items: flex-start;
	max-width: 1420px;
}

.promotion {
	width: 40%;
	margin: 30px 0 60px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: flex-start;
	position: relative;

	.vertical-divider {
		width: 1px;
		height: auto;
		background: #3c3834;
		position: absolute;
		right: 0;
		top: 0;
		bottom: 40px;
	}

	.horizontal-divider {
		height: 1px;
		width: 100%;
		margin: 20px 0;
	}

	.details {
		font-size: var(--body-font-size);
		font-weight: 900;
	}

	&:nth-child(even) {
		.vertical-divider {
			display: none;
		}
	}

	&:nth-child(odd) {
		.vertical-divider {
			display: block;
		}
	}

	&:last-child {
		.vertical-divider {
			display: none;
		}
	}

	.card-wrapper {
		width: calc(100% - 60px);
	}
}

.special-content {
	padding: 40px 0;

	h4 {
		color: var(--body-color);
		font-size: var(--body-font-size);
		font-weight: 500;
	}

	.available-at {
		display: grid;
		grid-template-columns: 1fr 1fr;
		align-content: center;

		div {
			margin: 5px 0;
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			align-items: center;

			span {
				font-size: var(--button-font-size);
				margin: 0;
				color: #000;
			}

			img {
				margin: 0 12px 0 0;
				width: 40px;
				height: 40px;
			}
		}
	}
}

.card {
	width: 100%;
	perspective: 700px;

	.content {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
		display: block;

		:deep(p) {
			margin: unset;
		}
	}

	.front,
	.back {
		position: absolute;
		width: 100%;
		height: 100%;
		backface-visibility: hidden;
		inset: 0;
		border-radius: 40px;
	}

	.front {
		color: var(--body-color);
		position: relative;
	}

	.back {
		background: #9fa99b;
		color: var(--body-color);
		transform: rotateY(180deg);
		padding: 40px;
		text-decoration: none;

		&::after {
			display: none;
		}

		&.blue {
			background: #ccd9d9;
		}

		&.red {
			background: #f7b39d;
		}

		&.yellow {
			background: #eae4e4;
		}

		&.peach {
			background: #f4d9c2;
		}
	}

	&:hover {
		.content {
			transform: rotateY(180deg);
			transition: transform 0.8s;
		}
	}

	.content-wrapper {
		height: 100%;
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;

		h3 {
			color: var(--body-color);
		}
	}
}

@media (max-width: 1280px) {
	.promotion {
		width: 45%;

		&:nth-child(even) {
			.vertical-divider {
				display: none;
			}
		}

		&:nth-child(odd) {
			.vertical-divider {
				display: block;
			}
		}

		&:last-child {
			.vertical-divider {
				display: none;
			}
		}
	}
}

@media (max-width: 880px) {
	.special-content .available-at {
		grid-template-columns: 1fr;
	}

	.promotion {
		width: 100%;
		padding: 0;

		.vertical-divider {
			display: none !important;
		}
	}
}
</style>
